import * as api from './request-team.api';
import * as queries from './request-team.queries';
import * as mutations from './request-team.mutations';

export * from './request-team.api';
export * from './request-team.queries';
export * from './request-team.mutations';

export default { ...api, ...queries, ...mutations };
